import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import * as dayjs from 'dayjs';
import Swiper, {SwiperOptions} from 'swiper';
import {ICruiseDetailSolution} from '../../cruise-detail-page/interfaces/icruise-detail-solution';
import {CruiseBookingService} from '../../cruise-booking-page/services/cruise-booking.service';
import {Observable, Subscription} from 'rxjs';
import {ICruiseDetail} from '../../cruise-detail-page/interfaces/icruise-detail';


@Component({
  selector: 'cruise-detail-generic-page-dates',
  templateUrl: './cruise-detail-generic-page-dates.component.html',
  styleUrls: ['./cruise-detail-generic-page-dates.component.scss']
})
export class CruiseDetailGenericPageDatesComponent implements OnInit, OnDestroy {

  @Input() cruiseDetail: ICruiseDetail;

  public swiper: Swiper;
  public selectedSolution: ICruiseDetailSolution;

  public config: SwiperOptions = {
    breakpoints: {
      320: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 4
      },
      1200: {
        slidesPerView: 5
      }
    },
    simulateTouch: false,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

  public index;

  private selectedSolutionSubscription: Subscription;


  constructor(private _cruiseBookingService: CruiseBookingService) {
  }

  ngOnInit(): void {

    setTimeout(() => {
      if (!this.selectedSolution && this.cruiseDetail?.solutions?.length) {
        this._cruiseBookingService.selectedSolution$.next(this.cruiseDetail?.selectedSolution || this.cruiseDetail.solutions[0]);
      }
    }, 100);

    this.selectedSolutionSubscription = this._cruiseBookingService.selectedSolution$
      .subscribe((solution) => {
        if (solution) {
          this.selectedSolution = solution;
        }
      });
  }

  ngOnDestroy(): void {
    this.selectedSolutionSubscription?.unsubscribe();
  }

  selectSolution(solution: ICruiseDetailSolution): void {
    this._cruiseBookingService.selectedSolution$.next(solution);
  }

}
